import type { FaireProductEntity } from "../../entity_types/product";

export const p_asmd72a4: FaireProductEntity = {
  token: "p_asmd72a4",
  type: "product",
  name: "Piñon - 3.5 oz Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/30d129a2d9eb591b998364e01877385d381583e8802b61764b56dc749cb2591f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0ce4ecf717993ed5452d5f5ddc825694dcba1a2f0f641d5b75b0cc8d28d1ff7.jpeg",
    "https://cdn.faire.com/fastly/fdf6aa63157bb2db790b17c2aacbaad472d08c505557d050205a6f22b3259754.jpeg",
    "https://cdn.faire.com/fastly/684b102beb292a8c2e638fa6b79287989799edc67f2cadc7c36e8ea7a1d05877.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/3ec3b40ddf2d4f1d916cabf565664c386c5376775b70151546c6ca3cbe6a81fc.jpeg",
    "https://cdn.faire.com/fastly/3b84c7448c1fd4ba405db55ed07ec4e0f06691eb41a63bb53f5e1efcda2c2e1c.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'Winters in the Southwest, lingering bonfires, wool jackets in rotation. Notes of piñon logs, cedar, and vanilla.\n\nLow-maintenance, flame-free, and always-on scent for entry ways, bathrooms, dorm rooms, and bedrooms.\n\nEach diffuser contains a 3.5 fl oz blend of naturally-derived and man-made fragrance oils in a 4 oz amber apothecary-inspired bottle. Includes a bundle of 9" long naturally-harvested rattan reeds to absorb and slowly release the fragrance. \n\nLasts approximately 3-4 months, flip reeds weekly.',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:57.147Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
